EMMY.homePage = {
  init: function () {
    document.querySelector('.home').classList += ' ready';
  }
};